import * as constants from "../../../shared/util/constant";
import { CommonUtility } from '../../../Services/CommonUtility';
import { sendEmailDocuments } from "../../services/CustomerAPI";
import SendDocumentByEmailQuery from "../../model/EmailDocumentModel/SendDocumentByEmailQuery";

const SUBJECT_LENGTH = 988;

class SliderEmailDocumentService {

     public validateEmailDoc = (selectedDocs : string[], recipient:string, subject:string, body:string) => {
            let validationErrors = {};            
            if (!selectedDocs || selectedDocs.length === 0) {
                validationErrors['selectedDocs'] = {isValid : false, warningText : constants.EmailDocuments.VALIDATION_DOCUMENT_SELECTION };
            }
    
            if (!subject || subject?.trim().length == 0) {
                validationErrors['subject'] = {isValid : false, warningText : constants.FIELD_BLANK };
            } else if (subject.length > SUBJECT_LENGTH) {
               validationErrors['subject'] = {isValid : false, warningText : constants.EmailDocuments.VALIDATION_SUBJECTLINE_LIMIT + " (<="+ SUBJECT_LENGTH +")" };
            }
    
            if (!recipient.trim()) {
                validationErrors['recipient'] = {isValid : false, warningText : constants.FIELD_BLANK };
            }

            if (!body.trim() || body?.trim().length == 0) {
                validationErrors['body'] = {isValid : false, warningText : constants.FIELD_BLANK };
            }
            
            return validationErrors;
        }

         public sendEmailDocuments = async (sendDocumentByEmailQuery: SendDocumentByEmailQuery) => {
                var data = await sendEmailDocuments(sendDocumentByEmailQuery);
                return data;
            }
};
export default SliderEmailDocumentService;